import { apiRequest } from "@/utils/request"

export function getAdd(data){
	return apiRequest({
			url: `/guide/h5/ad/page`,
			method: 'post',
			data: data
	})
}
export function getUploadConfig(data){
	return apiRequest({
			url: `/guide/h5/upload/config`,
			method: 'post',
			data: data
	})
}

export function getApp(data){
	return apiRequest({
			url: `/guide/h5/app/page`,
			method: 'post',
			data: data
	})
}
export function getAppResource(data){
	return apiRequest({
			url: `/guide/h5/appResource/page`,
			method: 'post',
			data: data
	})
}
// 渠道统计
export function downloadCount(data){
	return apiRequest({
			url: `/guide/h5/download/add`,
			method: 'post',
			data: data
	})
}
export function verifyChannel(data){
	return apiRequest({
			url: `/guide/h5/label/verifyChannel`,
			method: 'post',
			data: data
	})
}

